type LottieJson = {
  assets: Array<{id: string}>;
};

type LottieImageReplacements = Record<string, string>;

export function fixAssetsPathForLottieImages(
  json: LottieJson,
  replacements: LottieImageReplacements,
) {
  return {
    ...json,
    assets: json.assets.map((asset) => {
      if (asset.id in replacements) {
        return {
          ...asset,
          u: '',
          p: replacements[asset.id],
        };
      }

      return asset;
    }),
  };
}
